import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../rootReducer";
import { AppStripId } from "@/components/AppStrip/appStripTypes";

export type AppId = AppStripId;
import { getAppStripIdFromPath } from "@/utils/getAppStripIdFromPath";

interface AppStripState {
  /** Currently active app in the strip */
  activeApp: AppStripId | null;
  /**
   * Focus mode: a course or learning path is open, so MainLayout hides the
   * app strip and the sub-menu. Set by useFocusMode on the pages themselves.
   */
  focusMode: boolean;
}

const initialState: AppStripState = {
  activeApp: getAppStripIdFromPath(window.location.pathname) ?? "resources",
  focusMode: false,
};

const appStripSlice = createSlice({
  name: "appStrip",
  initialState,
  reducers: {
    setActiveApp: (state, action: PayloadAction<AppStripId | null>) => {
      state.activeApp = action.payload;
    },
    setFocusMode: (state, action: PayloadAction<boolean>) => {
      state.focusMode = action.payload;
    },
  },
});

export const { setActiveApp, setFocusMode } = appStripSlice.actions;

export const selectActiveApp = (state: RootState) => state.appStrip.activeApp;
export const selectFocusMode = (state: RootState) => state.appStrip.focusMode;

export default appStripSlice.reducer;
